import React, { useState, useEffect } from 'react';
import FormComponent from '../../../Reusable_Components/FormComponent';
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import { useParams } from 'react-router-dom';

const QuoteStatusInput = () => {
  const { statusId = '' } = useParams();
  const decodedId = statusId ? atob(statusId) : statusId;
  const id = decodedId.replace(/\D/g, '');
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const route = 'quoteStatus';

  useEffect(() => {
    if (statusId) { setIsEditing(true); fetchDetails(); }
  }, [statusId]);

  const fetchDetails = async () => {
    try {
      const response = await axios.get(API_DOMAIN + API_ROUTES['quoteStatus'] + id + '/', { headers });
      setFormData(response.data);
    } catch (error) { console.error('Error fetching Quote Status details:', error); }
  };

  const fields = [{"name":"name","label":"Name","type":"text"},{"name":"description","label":"Description","type":"textarea"},{"name":"is_final","label":"Is Final","type":"checkbox"}];

  return (
    <div>
      <h1>{isEditing ? 'Edit Quote Status' : 'Create Quote Status'}</h1>
      <FormComponent fields={fields} initialFormData={formData} route={route} />
    </div>
  );
};

export default QuoteStatusInput;